import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ArtistictreeComponent } from "./artistictree/artistictree.component";
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import {ReportengineModule} from '../../reportengine/reportengine.module'
import { ReportOptionsPopupComponent } from "../common/reportOptions/reportOptionsPopup/report-options-popup.component";



@NgModule({
    declarations: [ArtistictreeComponent],
    imports: [
        ReportengineModule,
        CommonModule,
        FormsModule,
        SharedModule
    ],
    exports: []
})
export class ArtisticTreeModule {}

// translation loader moved to SharedModule
